/*
 * @Author: dengfang 36882215@qq.com
 * @Date: 2024-02-03 16:44:54
 * @LastEditors: dengfang 36882215@qq.com
 * @LastEditTime: 2024-02-04 18:11:41
 * @FilePath: /backyard-ms/src/util/get-page-title.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'

const title = 'Pop HR'

export default function getPageTitle(key) {
  if (!key) return title
  const hasKey = Vue.prototype.$t(key)
  if (hasKey) {
    return `${hasKey} - ${title}`
  }
  return `${title}`
}
